import { gql } from "@apollo/client";

const FIND_SNAPSHOTS_BY_PRODUCT = gql`
  query FindSnapshotsByProduct($productId: ID!, $startDate: String!, $endDate: String!, $quarter: Int!, $year: Int!) {
    findSnapshotsByProduct(productId: $productId, startDate: $startDate, endDate: $endDate, quarter: $quarter, year: $year) {
      ... on DailySnapshot {
        _id
        snapshotType
        createdAt
        totals {
          balance
        }
      }
      ... on QuarterlySnapshot {
        _id
        snapshotType
        createdAt
        totals {
          balance
        }
      }
      ... on WeeklySnapshot {
        _id
        snapshotType
        createdAt
        totals {
          balance
        }
      }
    }
  }
`;

export { FIND_SNAPSHOTS_BY_PRODUCT };

